import { checkStatus, csrfToken } from 'common/http';

import {
  SET_CONTACT_FORM_FIELD,
  SEND_CONTACT_FORM,
  RESET_CONTACT_FORM,
  HANDLE_CONTACT_FORM_SUCCESS,
  HANDLE_CONTACT_FORM_FAILURE,
  SHOW_CONTACT_FORM_NOTIFICATION,
  HIDE_CONTACT_FORM_NOTIFICATION
} from '../actionTypes';
import { Dispatcher, GetState } from 'datasetLandingPage/lib/types';
import {
  ContactFormAction,
  ContactFormField
} from 'datasetLandingPage/components/ContactForm/types/contactForm';

export function setContactFormField(field: string, value: ContactFormField): ContactFormAction {
  return {
    type: SET_CONTACT_FORM_FIELD,
    field,
    value
  };
}

export function showContactFormNotification(): ContactFormAction {
  return { type: SHOW_CONTACT_FORM_NOTIFICATION };
}

export function hideContactFormNotification() {
  return { type: HIDE_CONTACT_FORM_NOTIFICATION };
}

export function sendContactForm(): ContactFormAction {
  return {
    type: SEND_CONTACT_FORM
  };
}

export function resetContactForm(): ContactFormAction {
  return {
    type: RESET_CONTACT_FORM
  };
}

export function handleContactFormSuccess(): ContactFormAction {
  return {
    type: HANDLE_CONTACT_FORM_SUCCESS
  };
}

export function handleContactFormFailure(): ContactFormAction {
  return {
    type: HANDLE_CONTACT_FORM_FAILURE
  };
}

export function submitContactForm() {
  return (dispatch: Dispatcher, getState: GetState) => {
    const state = getState();
    const viewId = state.view.id;
    const { fields } = state.contactForm;

    dispatch(sendContactForm());

    // Send off email request
    fetch(`/datasets/${viewId}/contact_dataset_owner`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken()
      },
      body: JSON.stringify({
        id: viewId,
        type: 'other',
        subject: fields.subject.value,
        message: fields.message.value,
        from_address: fields.email.value
      })
    })
      .then(checkStatus)
      .then((response) => response.json())
      .then(() => {
        dispatch(handleContactFormSuccess());
      })
      .catch((error) =>
        error.response.json().then(() => {
          dispatch(handleContactFormFailure());
        })
      );
  };
}
